import { useMemo } from 'react';
import { IPageLink } from '@vivli/shared/infrastructure/interface';

export const useDefaultLink = (pageLinks: IPageLink[], defaultTab?: string) => {
    return useMemo(() => {
        if (defaultTab) {
            return pageLinks.find((l) => l.url === defaultTab);
        }

        return pageLinks[0];
    }, [pageLinks, defaultTab]);
};
